import { Box } from '@mui/material';

const TabPanel = ({ activeTab, index, children }) => (
  <Box
    role="tabpanel"
    hidden={activeTab !== index}
    sx={{
      display: activeTab === index ? 'block' : 'none',
    }}
  >
    {activeTab === index ? children : null}
  </Box>
);

export default TabPanel;
